/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from 'ethers'
import { Provider, TransactionRequest } from '@ethersproject/providers'
import type {
  GammaShortStrategy,
  GammaShortStrategyInterface
} from '../GammaShortStrategy'

const _abi = [
  {
    inputs: [],
    stateMutability: 'nonpayable',
    type: 'constructor'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'owner',
        type: 'address'
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'spender',
        type: 'address'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'value',
        type: 'uint256'
      }
    ],
    name: 'Approval',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'int256',
        name: 'delta',
        type: 'int256'
      }
    ],
    name: 'DeltaHedged',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'account',
        type: 'address'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'strategyTokenAmount',
        type: 'uint256'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'depositedAmount',
        type: 'uint256'
      }
    ],
    name: 'DepositedToStrategy',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'uint256',
        name: 'hedgeInterval',
        type: 'uint256'
      }
    ],
    name: 'HedgeIntervalUpdated',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'uint256',
        name: 'hedgeSqrtPriceThreshold',
        type: 'uint256'
      }
    ],
    name: 'HedgePriceThresholdUpdated',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'uint8',
        name: 'version',
        type: 'uint8'
      }
    ],
    name: 'Initialized',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'address',
        name: 'operator',
        type: 'address'
      }
    ],
    name: 'OperatorUpdated',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'from',
        type: 'address'
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'to',
        type: 'address'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'value',
        type: 'uint256'
      }
    ],
    name: 'Transfer',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'account',
        type: 'address'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'strategyTokenAmount',
        type: 'uint256'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'withdrawnAmount',
        type: 'uint256'
      }
    ],
    name: 'WithdrawnFromStrategy',
    type: 'event'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'owner',
        type: 'address'
      },
      {
        internalType: 'address',
        name: 'spender',
        type: 'address'
      }
    ],
    name: 'allowance',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'spender',
        type: 'address'
      },
      {
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256'
      }
    ],
    name: 'approve',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'account',
        type: 'address'
      }
    ],
    name: 'balanceOf',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'checkPriceHedge',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'checkTimeHedge',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'decimals',
    outputs: [
      {
        internalType: 'uint8',
        name: '',
        type: 'uint8'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'spender',
        type: 'address'
      },
      {
        internalType: 'uint256',
        name: 'subtractedValue',
        type: 'uint256'
      }
    ],
    name: 'decreaseAllowance',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_strategyTokenAmount',
        type: 'uint256'
      },
      {
        internalType: 'address',
        name: '_recepient',
        type: 'address'
      },
      {
        internalType: 'uint256',
        name: '_maxDepositAmount',
        type: 'uint256'
      },
      {
        internalType: 'bool',
        name: 'isQuoteMode',
        type: 'bool'
      },
      {
        components: [
          {
            internalType: 'uint256',
            name: 'lowerSqrtPrice',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'upperSqrtPrice',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'deadline',
            type: 'uint256'
          }
        ],
        internalType: 'struct IStrategyVault.StrategyTradeParams',
        name: '_tradeParams',
        type: 'tuple'
      }
    ],
    name: 'deposit',
    outputs: [
      {
        internalType: 'uint256',
        name: 'finalDepositMargin',
        type: 'uint256'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_initialMarginAmount',
        type: 'uint256'
      },
      {
        internalType: 'int256',
        name: '_initialPerpAmount',
        type: 'int256'
      },
      {
        internalType: 'int256',
        name: '_initialSquartAmount',
        type: 'int256'
      },
      {
        components: [
          {
            internalType: 'uint256',
            name: 'lowerSqrtPrice',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'upperSqrtPrice',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'deadline',
            type: 'uint256'
          }
        ],
        internalType: 'struct IStrategyVault.StrategyTradeParams',
        name: '_tradeParams',
        type: 'tuple'
      }
    ],
    name: 'depositForPositionInitialization',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: 'uint256',
            name: 'lowerSqrtPrice',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'upperSqrtPrice',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'deadline',
            type: 'uint256'
          }
        ],
        internalType: 'struct IStrategyVault.StrategyTradeParams',
        name: '_tradeParams',
        type: 'tuple'
      }
    ],
    name: 'execDeltaHedge',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [],
    name: 'getPrice',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'spender',
        type: 'address'
      },
      {
        internalType: 'uint256',
        name: 'addedValue',
        type: 'uint256'
      }
    ],
    name: 'increaseAllowance',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '_controller',
        type: 'address'
      },
      {
        internalType: 'address',
        name: '_reader',
        type: 'address'
      },
      {
        internalType: 'uint256',
        name: '_assetId',
        type: 'uint256'
      },
      {
        components: [
          {
            internalType: 'uint256',
            name: 'lower',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'upper',
            type: 'uint256'
          }
        ],
        internalType: 'struct BaseStrategy.MinPerValueLimit',
        name: '_minPerValueLimit',
        type: 'tuple'
      },
      {
        internalType: 'string',
        name: '_name',
        type: 'string'
      },
      {
        internalType: 'string',
        name: '_symbol',
        type: 'string'
      }
    ],
    name: 'initialize',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [],
    name: 'lastHedgePrice',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'lastHedgeTimestamp',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'name',
    outputs: [
      {
        internalType: 'string',
        name: '',
        type: 'string'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'operator',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        components: [
          {
            components: [
              {
                internalType: 'int256',
                name: 'perpEntryUpdate',
                type: 'int256'
              },
              {
                internalType: 'int256',
                name: 'sqrtEntryUpdate',
                type: 'int256'
              },
              {
                internalType: 'int256',
                name: 'sqrtRebalanceEntryUpdateUnderlying',
                type: 'int256'
              },
              {
                internalType: 'int256',
                name: 'sqrtRebalanceEntryUpdateStable',
                type: 'int256'
              },
              {
                internalType: 'int256',
                name: 'perpPayoff',
                type: 'int256'
              },
              {
                internalType: 'int256',
                name: 'sqrtPayoff',
                type: 'int256'
              }
            ],
            internalType: 'struct Perp.Payoff',
            name: 'payoff',
            type: 'tuple'
          },
          {
            internalType: 'int256',
            name: 'fee',
            type: 'int256'
          },
          {
            internalType: 'int256',
            name: 'minDeposit',
            type: 'int256'
          }
        ],
        internalType: 'struct DataType.TradeResult',
        name: '_tradeResult',
        type: 'tuple'
      },
      {
        internalType: 'bytes',
        name: '_data',
        type: 'bytes'
      }
    ],
    name: 'predyTradeCallback',
    outputs: [
      {
        internalType: 'int256',
        name: '',
        type: 'int256'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '_newOperator',
        type: 'address'
      }
    ],
    name: 'setOperator',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [],
    name: 'symbol',
    outputs: [
      {
        internalType: 'string',
        name: '',
        type: 'string'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'totalSupply',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'to',
        type: 'address'
      },
      {
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256'
      }
    ],
    name: 'transfer',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'from',
        type: 'address'
      },
      {
        internalType: 'address',
        name: 'to',
        type: 'address'
      },
      {
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256'
      }
    ],
    name: 'transferFrom',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'int256',
        name: '_squartAmount',
        type: 'int256'
      },
      {
        components: [
          {
            internalType: 'uint256',
            name: 'lowerSqrtPrice',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'upperSqrtPrice',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'deadline',
            type: 'uint256'
          }
        ],
        internalType: 'struct IStrategyVault.StrategyTradeParams',
        name: '_tradeParams',
        type: 'tuple'
      }
    ],
    name: 'updateGamma',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_hedgeInterval',
        type: 'uint256'
      }
    ],
    name: 'updateHedgeInterval',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_newSqrtPriceThreshold',
        type: 'uint256'
      }
    ],
    name: 'updateHedgePriceThreshold',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [],
    name: 'vaultId',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_withdrawStrategyAmount',
        type: 'uint256'
      },
      {
        internalType: 'address',
        name: '_recepient',
        type: 'address'
      },
      {
        internalType: 'int256',
        name: '_minWithdrawAmount',
        type: 'int256'
      },
      {
        components: [
          {
            internalType: 'uint256',
            name: 'lowerSqrtPrice',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'upperSqrtPrice',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'deadline',
            type: 'uint256'
          }
        ],
        internalType: 'struct IStrategyVault.StrategyTradeParams',
        name: '_tradeParams',
        type: 'tuple'
      }
    ],
    name: 'withdraw',
    outputs: [
      {
        internalType: 'uint256',
        name: 'finalWithdrawAmount',
        type: 'uint256'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'function'
  }
]

const _bytecode =
  '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'

export class GammaShortStrategy__factory extends ContractFactory {
  constructor(
    ...args: [signer: Signer] | ConstructorParameters<typeof ContractFactory>
  ) {
    if (args.length === 1) {
      super(_abi, _bytecode, args[0])
    } else {
      super(...args)
    }
  }

  deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<GammaShortStrategy> {
    return super.deploy(overrides || {}) as Promise<GammaShortStrategy>
  }
  getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {})
  }
  attach(address: string): GammaShortStrategy {
    return super.attach(address) as GammaShortStrategy
  }
  connect(signer: Signer): GammaShortStrategy__factory {
    return super.connect(signer) as GammaShortStrategy__factory
  }
  static readonly bytecode = _bytecode
  static readonly abi = _abi
  static createInterface(): GammaShortStrategyInterface {
    return new utils.Interface(_abi) as GammaShortStrategyInterface
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): GammaShortStrategy {
    return new Contract(address, _abi, signerOrProvider) as GammaShortStrategy
  }
}
